import { colors } from "@murm/charts";
import styles from "./formatText.module.css";

// Colors for support/oppose text (same palette as charts package)
export const OPPOSE_COLOR = colors.chartColors.oppose;
export const SUPPORT_COLOR = colors.chartColors.support;

// Function to format title from snake_case to Title Case
export const formatTitle = (text) => {
  if (text == null || text === "") return "";
  return String(text)
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Function to color-code support/oppose text
export const colorCodeText = (text) => {
  if (!text) return null;

  const cleanedText = text.replace(/,\s*/g, " ");

  const parts = cleanedText.split(/(support|oppose|agree|disagree)/i);
  return (
    <span>
      {parts.map((part, i) => {
        const lowerPart = part.toLowerCase();
        if (lowerPart === "support" || lowerPart === "agree") {
          return (
            <span key={i} className={styles.support}>
              {part}
            </span>
          );
        } else if (lowerPart === "oppose" || lowerPart === "disagree") {
          return (
            <span key={i} className={styles.oppose}>
              {part}
            </span>
          );
        }
        return part;
      })}
    </span>
  );
};
